import api from './config';
import axios from 'axios';

const API_URL = '/api/auth';

// Register User
const register = async (userData, userType) => {
  try {
    // Don't set Content-Type manually — the shared api instance's
    // interceptor (config.js) already strips it for FormData bodies so
    // axios can set the correct multipart boundary automatically.
    const response = await api.post(`${API_URL}/register/${userType}`, userData);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Login User
const login = async (email, password) => {
  try {
    const response = await api.post(`${API_URL}/login`, { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Logout User
const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Get current user
const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

// Check if user is authenticated
const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

// Get auth token
const getToken = () => {
  return localStorage.getItem('token');
};

// Register Academia
const registerAcademia = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/register/academia`, formData, {
      headers: {
        'Authorization': `Bearer ${getToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Register Incubator
const registerIncubator = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/register/incubator`, formData, {
      headers: {
        'Authorization': `Bearer ${getToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Register Investor
const registerInvestor = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/register/investor`, formData, {
      headers: {
        'Authorization': `Bearer ${getToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Register Startup
const registerStartup = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/register/startup`, formData, {
      headers: {
        'Authorization': `Bearer ${getToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Register Association
const registerAssociation = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/register/association`, formData, {
      headers: {
        'Authorization': `Bearer ${getToken()}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const authApi = {
  register,
  login,
  logout,
  getCurrentUser,
  isAuthenticated,
  getToken,
  registerAcademia,
  registerIncubator,
  registerInvestor,
  registerStartup,
  registerAssociation
};

export default authApi;
